class CardLink {
	constructor() {
		this.cards = document.querySelectorAll(".card-link");

		if (!this.cards) {
			return;
		}

		this.buildCardLink();
	}

	buildCardLink() {
		this.cards.forEach(link => {
			const arrow = `
				<div class="arrow">
					<svg width="21" height="10" viewBox="0 0 21 10">
						<path d="M20.002 4.99908C19.995 4.82032 19.9214 4.61365 19.7988 4.48336L15.7983 0.232834C15.5273 -0.0108047 15.0074 -0.111261 14.7045 0.170399C14.4061 0.447872 14.4149 0.985743 14.7121 1.26425L17.5249 4.24899H0.750115C0.335911 4.24899 0 4.58489 0 4.99911C0 5.41333 0.335898 5.74922 0.750115 5.74922H17.5249L14.7121 8.73397C14.4561 8.99034 14.4088 9.54739 14.7045 9.82782C14.9999 10.1084 15.5383 10.0188 15.7983 9.76521L19.7988 5.51468C19.9357 5.36923 20.0023 5.19849 20.002 4.99896V4.99908Z"/>
					</svg>
				</div>`;


			const inner = link.querySelector(".card-link-inner");

			if (inner) {
				inner.insertAdjacentHTML("beforeend", arrow);

				const pointer = link.querySelector(".arrow");

				link.addEventListener("mouseenter", (e) => {
					pointer.classList.add("active");
					let pointerOffsetTop = e.clientY - link.getBoundingClientRect().top;
					let pointerOffsetLeft = e.clientX - link.getBoundingClientRect().left;

					gsap.to(pointer, {
						duration: 0,
						css: {
							top: pointerOffsetTop,
							left: pointerOffsetLeft
						}
					});
				});

				link.addEventListener("mousemove", (e) => {
					let pointerOffsetTop = e.clientY - link.getBoundingClientRect().top;
					let pointerOffsetLeft = e.clientX - link.getBoundingClientRect().left;

					gsap.to(pointer, {
						duration: 0.3,
						css: {
							top: pointerOffsetTop,
							left: pointerOffsetLeft
						},
						ease: Power1.easeOut
					});
				});

				link.addEventListener("mouseleave", (e) => {
					pointer.classList.remove("active");
				});
			}
		});
	}
}